export const RMStockStatsColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "invoice_no",
    title: "Invoice No",
  },
  {
    id: "supplier_name",
    title: "Supplier",
  },
  {
    id: "rm_name",
    title: "Item",
  },
  {
    id: "price",
    title: "Price",
  },
  {
    id: "qty",
    title: "Quantity",
  },
  {
    id: "total_amount",
    title: "Total Amount",
  },
  {
    id: "desc",
    title: "Description",
  },
  {
    id: "date",
    title: "Date",
  },
];
